export const ID_SKIN_CONTAINER = 'playerContainer_skin';

export type SettingSectionName =
  | 'quality'
  | 'audio'
  | 'subtitles'
  | 'interactive';

export enum PlayerControlRole {
  // for onboarding
  favButton = 'favButton',
  shareButton = 'shareButton',
  seekBar = 'seekBar',
  timeBar = 'timeBar',
  volumeBar = 'volumeBar',
  tvProgramButton = 'tvProgramButton',

  // other
  footer = 'footer',
  settingsButton = 'settingsButton',
  settingsSectionScroller = 'settingsSectionScroller',
}
